export { default } from './TermsAndConditionsWidget'
export * from './TermsAndConditionsWidget'
